import './Badge.css';

// Shared pill/tag used for status, priority, and category labels across the
// app. Pass `tone` for one of the canonical semantic colors, or `style` for
// a custom color (e.g. the per-category colors in lib/finances.js).
export default function Badge({ children, tone, style, title }) {
  return (
    <span className={'badge' + (tone ? ` badge-${tone}` : '')} style={style} title={title}>
      {children}
    </span>
  );
}
